import InputAdornment from '@mui/material/InputAdornment';
import InsertCommentIcon from '@mui/icons-material/InsertComment';
import Input from '@mui/material/Input';
import { useNavigate } from 'react-router-dom'

// import logo from './logo.svg';
import logo from './logo.png';
import './App.css';
import React from 'react';
import { useParams } from "react-router-dom";
import Avatar from '@mui/material/Avatar';
import Stack from '@mui/material/Stack';
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Rating from '@mui/material/Rating';
import CenteredTabs from './questions.js'
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import SendIcon from '@mui/icons-material/Send';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import DownloadIcon from '@mui/icons-material/Download';
import Paper from '@mui/material/Paper';
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import axios from 'axios'
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Snackbar from '@mui/material/Snackbar';

import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { SwitchProps } from '@mui/material/Switch';
import Checkbox from '@mui/material/Checkbox';

const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  '& .MuiSwitch-track': {
    borderRadius: 22 / 2,
    '&:before, &:after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      transform: 'translateY(-50%)',
      width: 16,
      height: 16,
    },
    '&:before': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    '&:after': {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main),
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: 'none',
    width: 16,
    height: 16,
    margin: 2,
  },
}));

const IOSSwitch = styled((props: SwitchProps) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  width: 42,
  height: 26,
  padding: 0,
  '& .MuiSwitch-switchBase': {
    padding: 0,
    margin: 2,
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(16px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#65C466',
        opacity: 1,
        border: 0,
      },
      '&.Mui-disabled + .MuiSwitch-track': {
        opacity: 0.5,
      },
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff',
    },
    '&.Mui-disabled .MuiSwitch-thumb': {
      color:
        theme.palette.mode === 'light'
          ? theme.palette.grey[100]
          : theme.palette.grey[600],
    },
    '&.Mui-disabled + .MuiSwitch-track': {
      opacity: theme.palette.mode === 'light' ? 0.7 : 0.3,
    },
  },
  '& .MuiSwitch-thumb': {
    boxSizing: 'border-box',
    width: 22,
    height: 22,
  },
  '& .MuiSwitch-track': {
    borderRadius: 26 / 2,
    backgroundColor: theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500,
    }),
  },
}));


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: window.innerWidth-80,
  height: window.innerHeight-80,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  maxWidth: 500,
  textAlign: 'center',
  p: 4,
  overflowY: "auto",
  dir: 'rtl'

};

const selected = {borderColor:'#3aacd7', borderWidth: 2};
const unselected = {};
const good = [
  {id: 1, title: 'مراجعه به موقع تکنسین', selected: false},
  {id: 2, title: 'پاسخگویی خوب واحد خدمات', selected: false},
  {id: 3, title: 'هزینه مناسب خدمات', selected: false},
  {id: 4, title: 'کیفیت خوب کار', selected: false},
  {id: 5, title: 'رفتار محترمانه', selected: false},
]

const bad = [
  {id: 11, title: 'عدم مراجعه به موقع', selected: false},
  {id: 12, title: 'پاسخگویی بد واحد خدمات', selected: false},
  {id: 13, title: 'پیگیری نامناسب خدمات', selected: false},
  {id: 14, title: 'کیفیت نا مطلوب تکنسین', selected: false},
  {id: 15, title: 'هزینه بالای خدمات', selected: false},
]

function AdminApp() {
  const [value, setValue] = React.useState(0);
  const [explain, setExplain] = React.useState('');
  const [message, setMessage] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [razi, setRazi] = React.useState(false);
  const [warranty, setWarranty] = React.useState(false);
  const [pay, setPay] = React.useState(false);
  const [underTime, setUnderTime] = React.useState(false);
  const [upperTime, setUpperTime] = React.useState(false);
  const [ratingDisable, setRatingDisable] = React.useState(false);
  const [openSn, setOpenSn] = React.useState(false);
  const [invoiceInformation, setInvoiceInformation] = React.useState({});
  const [agent, setAgent] = React.useState();
  const [goodOptions, setGoodOptions] = React.useState(good);
  const [badOptions, setBadOptions] = React.useState(bad);
 const handleOpen = () => setOpen(true);
 const handleClose = () => setOpen(false);
 const [value2, setValue2] = React.useState(0);
 const navigate = useNavigate()

 const handleChange = (event: React.SyntheticEvent, newValue: number) => {
   setValue2(newValue);
 };
  const routeParams = useParams();

  const getInformation = async(invoiceNo) => {
    const response = await axios.post('https://api.fntpf.ir/rating/admindoing/information', {invoiceNo});
    if(response.data.status){
      setRatingDisable(response.data.done)
      setValue(response.data.score)
      setAgent(response.data.queryResponse.agent);
      setInvoiceInformation(response.data.queryResponse.invoice)
      console.log(response.data.queryResponse.invoice);
    }
  }
  React.useEffect(()=>{
    const invoiceNo =  Number(routeParams.invoiceNo);
    if(routeParams.invoiceNo) getInformation(invoiceNo)
  },[openSn])
  const renderSwitch =  (param)=>{
  switch (param) {
    case 1:
      return 'خیلی بد'
    case 2:
      return 'بد'
    case 3:
      return 'متوسط'
    case 4:
      return 'خوب'
    case 5:
      return 'عالی'
      break;
    default:
      return '-'
  }
}
const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'center',
  color: theme.palette.text.secondary,
  height: 60,
  lineHeight: '60px',
}));

const sendScore = async()=>{
  var data = {
    requestId: invoiceInformation.id,
    agentId: invoiceInformation.agent_id,
    underTime,
    upperTime,
    warranty,
    payment: pay,
    behavior: razi,
    comment: explain,
    // scoreOptions: JSON.stringify([...goodOptions, ...badOptions])
  }
  console.log(data);
  const response = await axios.post('https://api.fntpf.ir/rating/admin/insertscore', data);
  if(response.data.status) {
    console.log('OK');
    setMessage('با سپاس از همراهی شما')
    setOpenSn(true)
    setOpen(false)
    window.open(`https://panel.fntpf.ir/apps/invoice/preview/${routeParams.invoiceNo}`)
  }
  else {
    console.log('Failed!');
    setMessage('عدم ارتباط با سرور، لطفا بعدا تلاش کنید.')
    setOpenSn(true)
    setRatingDisable(false)
  }
}
  return (
    <div style={{alignItems: 'center', textAlign: '-webkit-center' }}>
    <div className="App" dir='rtl'>
      <header className="App-header">
      <Box
     sx={{
       pt: 1,
       width: '-webkit-fill-available',
       height: 'auto',

     }}>
     <img src={logo} width={200}/>
     <p style={{marginTop:-5}}>فناوران نوین پارسیان تصویر فدک</p>
     <h4 style={{marginTop:-10}}>نظرسنجی مشتری</h4>
     <p style={{marginTop:-10, fontSize:'10px'}}>شماره قبض: {invoiceInformation.id?invoiceInformation.id:''}</p>
     </Box>

        <Card sx={{width: '-webkit-fill-available', mt:2 }}>
          <CardContent>

          <Stack direction="row" spacing={2}>
             <Avatar
               alt="Remy Sharp"
               src={`https://api.fntpf.ir/assets/uploaded/images/${agent?agent.img_uri:'download.jpg'}`}
               sx={{ width: 72, height: 72, marginTop:20 }}
             />
             <div style={{marginRight:25, marginTop:-10, width:'100%'}}>
             <Grid container spacing={3}>
               <Grid item xs={6}>
                 <h4 style={{marginTop:5}}>
                   {agent ? `${agent.firstname} ${agent.lastname}` : ''}
                 </h4>
                 <p style={{fontSize: '12px', margin:0}}>
                   نام مشتری: {invoiceInformation.merchant_name? invoiceInformation.merchant_name : ''}
                 </p>
                 <p style={{fontSize: '12px', margin:0}}>
                   شماره تماس مشتری: {invoiceInformation.merchant_phone? invoiceInformation.merchant_phone : ''}
                 </p>
               </Grid>
               <Grid item xs={6} >
                 <h4 style={{marginTop:5}}>
                 {`استان ${invoiceInformation.merchant_province ? invoiceInformation.merchant_province : ''}`}

                 </h4>
                 <p style={{fontSize: '12px', margin:0}}>
                   {`${invoiceInformation.service_type ? invoiceInformation.service_type : ''} ${invoiceInformation.product_category ? invoiceInformation.product_category : ''}`}
                 </p>
               </Grid>
             </Grid>

             </div>
           </Stack>

          </CardContent>
        </Card>
        <br />
        <Card sx={{width: '-webkit-fill-available', mt:0 }}>
          <CardContent>

            <h5 variant="h5" component="div">
              لطفا موارد زیر را بررسی نمایید.
            </h5>

            <Grid container spacing={1} style={{alignItems:'center'}}>
              <Grid item xs={9} >
              <p style={{fontSize: '14px', textAlign: '-webkit-right'}}>
                از نحوه برخورد و عملکرد تکنسین راضی هستید؟
              </p>
              </Grid>
              <Grid item xs={3} >
              <Stack direction="row" spacing={1} alignItems="center">
                <p style={{fontSize: '12px'}}>بله</p>
                <FormGroup >
                <FormControlLabel style={{marginRight:1}}
                        control={<Android12Switch checked={razi} onChange={()=> setRazi(!razi)} />}
                      />
                </FormGroup>
                <p style={{fontSize: '12px'}}>خیر</p>
              </Stack>
              </Grid>

              <Grid item xs={9} >
              <p style={{fontSize: '14px', textAlign: '-webkit-right'}}>
                کار به صورت گارانتی انجام شده است؟
              </p>
              </Grid>
              <Grid item xs={3} >
              <Stack direction="row" spacing={1} alignItems="center">
                <p style={{fontSize: '12px'}}>بله</p>
                <FormGroup >
                <FormControlLabel style={{marginRight:1}}
                        control={<Android12Switch checked={warranty} onChange={()=> setWarranty(!warranty)} />}
                      />
                </FormGroup>
                <p style={{fontSize: '12px'}}>خیر</p>
              </Stack>
              </Grid>

              <Grid item xs={9} >
              <p style={{fontSize: '14px', textAlign: '-webkit-right'}}>
                آیا به تکنسین بابت کار انجام شده وجه پرداخت کردید؟
              </p>
              </Grid>
              <Grid item xs={3} >
              <Stack direction="row" spacing={1} alignItems="center">
                <p style={{fontSize: '12px'}}>بله</p>
                <FormGroup >
                <FormControlLabel style={{marginRight:1}}
                        control={<Android12Switch checked={pay} onChange={()=> setPay(!pay)} />}
                      />
                </FormGroup>
                <p style={{fontSize: '12px'}}>خیر</p>
              </Stack>
              </Grid>
              <Grid item xs={12} >
              <FormGroup>
                <FormControlLabel control={<Checkbox checked={underTime} onChange={()=> setUnderTime(!underTime)} />} label='کار در همان روز انجام شده است.' />
              </FormGroup>
              </Grid>

              <Grid item xs={12} >
              <FormGroup>
                <FormControlLabel control={<Checkbox checked={upperTime} onChange={()=> setUpperTime(!upperTime)} />} label='کار بالای 72 ساعت انجام شده است.' />
              </FormGroup>
              </Grid>
              <Grid item xs={12} >

              <Input style={{dir:'rtl', width: '100%', marginTop: 25}}
                multiline
                value= {explain}
                onChange={e => setExplain(e.target.value)}
                id="input-with-icon-adornment"
                placeholder='توضیحات مشتری'
                startAdornment={
                  <InputAdornment position="start">
                    <InsertCommentIcon />
                  </InputAdornment>
                }
              />
              </Grid>
              </Grid>
          </CardContent>
          <CardActions style={{justifyContent: 'end'}}>
            <Button disabled={ratingDisable} variant="contained"  onClick={ ()=>{
              setRatingDisable(true)
              sendScore()
            }
            }>ثبت اطلاعات</Button>
          </CardActions>
        </Card>
      </header>
    </div>
    <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        style={{
        overflowY: "auto"
        }}
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
      >
        <Fade in={open}>
        <Card sx={style}>
        <Rating
          dir='ltr'
          name="simple-controlled"
          value={value}
          size="large"
          onChange={(event, newValue) => {
            setValue(newValue);
            handleOpen();
            if(newValue > 3) setValue2(1)
            else setValue2(0)
          }}
        />
        <h5>{renderSwitch(value)}</h5>
          <Tabs value={value2} onChange={handleChange} variant="fullWidth">
            <Tab label="نقاط منفی" />
            <Tab label="نقاط مثبت" />
          </Tabs>
          { value2 == 1 &&
          <Grid container spacing={2} style={{textAlign:'center', marginTop:10}}>
               {good.map((item, index) => (
                 <Grid item xs={6} key={index}>
                 <Box
                   sx={{
                     display: 'flex',
                     '& > :not(style)': {
                       m: 1,
                       width: '100%',
                     },
                   }}
                 >
                   <Paper variant="outlined" elevation={4} onClick={()=>{
                     var nextList = [...goodOptions];
                     nextList[index].selected = !goodOptions[index].selected;
                     setGoodOptions(nextList)
                   }}
                     style={goodOptions[index].selected ? selected : unselected}>
                   <p style={{fontSize: '12px', margin:2, fontFamily: 'IRAN-sans'}}>
                   {item.title}
                   </p>
                   </Paper>
                 </Box>
                 </Grid>
               ))}
             </Grid>
          }
          { value2 == 0 &&
          <Grid container spacing={2} style={{textAlign:'center',  marginTop:10}}>
               {bad.map((item, index) => (
                 <Grid item xs={6} key={index}>
                 <Box
                   sx={{
                     display: 'flex',
                     '& > :not(style)': {
                       m: 1,
                       width: '100%',
                       pr: 1,
                       pl: 1
                     },
                   }}
                 >
                   <Paper variant="outlined" elevation={2} onClick={()=>{
                     var nextList = [...badOptions];
                     nextList[index].selected = !badOptions[index].selected;
                     setBadOptions(nextList)
                   }}
                     style={badOptions[index].selected ? selected : unselected}>
                   <p style={{fontSize: '12px', margin:2, fontFamily: 'IRAN-sans'}}>
                   {item.title}
                   </p>
                   </Paper>
                 </Box>
                 </Grid>
               ))}
             </Grid>
          }
          <Input style={{dir:'rtl', width: '100%', marginTop: 25}}
            multiline
            value= {explain}
            onChange={e => setExplain(e.target.value)}
            id="input-with-icon-adornment"
            placeholder='نوشتن نظر درباره این سفارش'
            startAdornment={
              <InputAdornment position="start">
                <InsertCommentIcon />
              </InputAdornment>
            }
          />
          <Grid container spacing={2} sx={{ mt:2 , mb:2}}>
            <Grid xs={8}>
              <Button style={{width: '100%'}} onClick={sendScore} variant="contained" endIcon={<SendIcon />}>ثبت</Button>
            </Grid>
            <Grid xs={4}>
              <Button style={{width: '100%'}} variant="outlined" endIcon={<DownloadIcon />}>فاکتور</Button>
            </Grid>
          </Grid>
        </Card>
        </Fade>
      </Modal>
      <Snackbar open={openSn} message={message} autoHideDuration={6000}/>
    </div>
  );
}

export default AdminApp;
